import SearchIcon from "@mui/icons-material/Search";
import {
  Button,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import DataGridComponent from "../../../../components/DataGridComponent";
import Loader from "../../../../components/Loader";
import PaginationComponent from "../../../../components/PaginationComponent";
import { showSnackbar } from "../../../../slice/snackbarSlice";
import { getPlan } from "../../../../thunks/plan";
import { PLAN_TABLE_COLUMNS } from "../../../../utils/TableColumns/PlanTableColumns";
import { PAGINATION_LIMIT } from "../../../../utils/constant";

const PlanTable = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tempPlanData = useSelector((state) => state?.plan?.planData);
  const [planData, setPlanData] = useState([]);
  const [isLoader, setLoader] = useState(false);
  const [search, setSearch] = useState("");
  const [paginationData, setPaginationData] = useState({
    currentPage: 1,
    itemsPerPage: PAGINATION_LIMIT,
    totalCount: 0,
  });
  // Calculate the index range for the current page
  const startIndex =
    (paginationData?.currentPage - 1) * paginationData?.itemsPerPage;
  const endIndex = startIndex + paginationData?.itemsPerPage;

  const getPlanData = async () => {
    try {
      setLoader(true);
      const response = await dispatch(getPlan()).unwrap();
      if (response) {
        setPlanData(response);
        setPaginationData({ ...paginationData, totalCount: response?.length });
        setLoader(false);
      }
    } catch (error) {
      setPlanData([]);
      setPaginationData({ ...paginationData, totalCount: 0 });
      dispatch(
        showSnackbar({
          message: `${error?.message}`,
          severity: "error",
        })
      );
      setLoader(false);
    }
  };

  /* Method to change search */
  const handleChangeSearch = (e) => {
    setSearch(e);
    const filterData = tempPlanData?.filter((value) =>
      value?.name?.toLowerCase().includes(e?.toLowerCase())
    );
    setPaginationData({
      ...paginationData,
      totalCount: filterData?.length,
      currentPage: 1,
    });
    setPlanData(filterData);
  };

  /* Method to change page --> Pagination */
  const handleChangePage = (event, value) => {
    setPaginationData({ ...paginationData, currentPage: value });
  };

  // DataGrid onRowClick Method
  const onRowClick = (e) => {
    navigate(`/app/manage/update-plan/${e?.row?.id}`);
  };

  useEffect(() => {
    getPlanData();
  }, []);

  return (
    <>
      <Grid container spacing={2} style={{ marginTop: "0px",marginLeft:"2px",width:"98%" }}>
        {/* Loader Component */}
        {isLoader && <Loader />}

        {/* Filter By Name Container */}

        <Grid item xs={3}>
          <TextField
            fullWidth
            placeholder="Search by name..."
            className="textField_outlined_border"
            size="small"
            value={search}
            onChange={(e) => handleChangeSearch(e?.target?.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "30px",
              },
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment>
                  <IconButton>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>

        {/* ADD PLAN BUTTON */}

        <Grid item xs={3}>
          <Button
            className="add_a_new_user_button"
            onClick={() => navigate("/app/manage/create-plan")}
          >
            Add a New Plan
          </Button>
        </Grid>

        {/* PLAN TABLE */}

        <Grid
          item
          xs={12}
          style={{ width: "100%", height: "80vh", overflow: "auto" }}
        >
          <DataGridComponent
            columns={PLAN_TABLE_COLUMNS}
            rows={planData?.slice(startIndex, endIndex)}
            onRowClick={onRowClick}
          />
        </Grid>

        {/* PAGINATION */}
        <PaginationComponent
          totalCount={paginationData?.totalCount}
          limit={paginationData?.itemsPerPage}
          page={paginationData?.currentPage}
          onChange={handleChangePage}
        />
      </Grid>
    </>
  );
};

export default PlanTable;
